import PropertyDataSlideItem from './PropertyDataSlideItem';

export default PropertyDataSlideItem;
